var map = {
	"./ads.jpg": 520,
	"./consulting-small.jpg": 521,
	"./consulting.jpg": 522,
	"./consulting2.jpg": 523,
	"./eye.jpg": 524,
	"./happiness.jpg": 525,
	"./instore.jpg": 526,
	"./klantervaring.jpg": 527,
	"./literature.jpg": 528,
	"./man-gift-happiness.jpg": 529,
	"./online-offline-interactie.jpg": 530,
	"./packaging.jpg": 531,
	"./salience.jpg": 532,
	"./shopalong.jpg": 533,
	"./shopper/heatmap-annotated.jpg": 534,
	"./shopper/heatmap1.jpg": 535,
	"./shopper/heatmap2.jpg": 536,
	"./shopper/heatmap3.jpg": 537,
	"./shopper_experience.jpg": 538,
	"./store-eyetrack.jpg": 539,
	"./traffic.jpg": 540,
	"./ux.jpg": 541,
	"./visual-communication.jpg": 542,
	"./wayfinding.jpg": 543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 519;